'use strict'
import Message from "../utils/Message";
import Form from "../utils/Form";

class ServiceFind {
    constructor(){
		var self=this;

        new Form().done((data) => {
			if(data.status==200){
				var str=location.pathname;
				if (str.charAt(str.length - 1) !== '/') {
					str = str + '/';
				}
				location.href = location.origin + str + 'completado/' + location.search;
			}
        });

		self.myMarker=false;
		self.activeRoute=false;
		
		if(location.protocol=='http:'){
			$('.btnGetGeoPosition').hide();
		}
		
		if ($(window).width() > 768) {
			self.initDesktop();
		}else{
			self.initMobile();
		}
	}
	
    initDesktop(){
		var self=this;

		$('#map').css({'width' : '100%', 'height' : '100%'});
		google.maps.event.addDomListener(window, 'load', function(){
			var autocomplete = new google.maps.places.Autocomplete(
				document.getElementById("search"),
				{ types: ["geocode"] }
			);
			autocomplete.setComponentRestrictions({
				country: ["pr"]
			});
			autocomplete.addListener('place_changed', function() {
				var place = autocomplete.getPlace();
				var latitude = place.geometry.location.lat();
				var longitude = place.geometry.location.lng();

				self.map.setCenter(new google.maps.LatLng(latitude, longitude) );
				self.map.setZoom(14);

				$('.serviceForm .btnSearch, .serviceForm .searchBtn').removeClass('disabled');
				self.searchDesktop(latitude, longitude);
			});

			self.map = new google.maps.Map(document.getElementById('map'), {
				zoom: 9,
				center: new google.maps.LatLng(18.2388, -66.435249),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true,
				zoomControl: true,
				scaleControl: true,
				scrollwheel: true,
			});

			$('.serviceForm .btnSearch').on('click', function (evt) {
				evt.preventDefault();

				if ($('#search').val().trim() != '') {
					var geocoder = new google.maps.Geocoder();
					geocoder.geocode({'address': $('#search').val(), componentRestrictions: {country: "PR"}}, function (results, status) {
						if (status == 'OK') {
							self.map.setCenter(new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()) );
							self.map.setZoom(14);
							self.searchDesktop(results[0].geometry.location.lat(), results[0].geometry.location.lng());
						} else {
							Message.error("No se encontró la dirección ingresada.");
						}
					});
				}
			});
			
			$('.btnGetGeoPosition').on('click', function(evt){
				evt.preventDefault();
				if (navigator.geolocation){
					navigator.geolocation.getCurrentPosition(
						function(position){
							var latitude=position.coords.latitude;
							var longitude=position.coords.longitude;
							self.map.setCenter(new google.maps.LatLng(latitude, longitude) );
							self.map.setZoom(14);
							$('.serviceForm .btnSearch').removeClass('disabled');
							
							var latlng = new google.maps.LatLng(latitude, longitude);          
							var geocoder = new google.maps.Geocoder();
							 geocoder.geocode({ 'latLng': latlng }, function (results, status) {
								if (status == google.maps.GeocoderStatus.OK) {
									if (results[0]) {
										for (var j = 0; j < results[0].address_components.length; j++) {
											if (results[0].address_components[j].types[0] == 'postal_code'){
												$('#search').val(results[0].address_components[j].short_name);
											}
										}
									}
								}
							 });
							 self.searchDesktop(latitude, longitude);
						}, 
						function (error){
							switch(error.code) {
							  case error.PERMISSION_DENIED:
								Message.error("El usuario ha denegado el permiso a la localización.");
								break;
							  case error.POSITION_UNAVAILABLE:
								Message.error("La información de la localización no está disponible.");
								break;
							  case error.TIMEOUT:
								Message.error("El tiempo de espera para buscar la localización ha expirado.");
								break;
							  case error.UNKNOWN_ERROR:
								Message.error("Ha ocurrido un error desconocido.");
								break;
							  default:
								Message.error(error.message);
								break;
							  }
							}
					);
				}else {
					$('.btnGetGeoPosition').hide();
				}
			});
		});
    }
	
	initMobile(){
		var self=this;
		
		$('#map').parent('hide');
		
		google.maps.event.addDomListener(window, 'load', function(){
			self.maps_mobile={};
		
			var autocomplete = new google.maps.places.Autocomplete(
				document.getElementById("search"),
				{ types: ["geocode"] }
			);
			autocomplete.setComponentRestrictions({
				country: ["pr"]
			});
			autocomplete.addListener('place_changed', function() {
				var place = autocomplete.getPlace();
				var latitude = place.geometry.location.lat();
				var longitude = place.geometry.location.lng();

				for(i in self.maps_mobile){
					self.maps_mobile[i].setCenter(new google.maps.LatLng(latitude, longitude) );
					self.maps_mobile[i].setZoom(14);
				}

				$('.serviceForm .searchBtn').removeClass('disabled');
				self.searchMobile(latitude, longitude);
			});

			$('.serviceForm .searchBtn').on('click', function (evt) {
				evt.preventDefault();

				if ($('#search').val().trim() != '') {
					var geocoder = new google.maps.Geocoder();
					geocoder.geocode({'address': $('#search').val(), componentRestrictions: {country: "PR"}}, function (results, status) {
						if (status == 'OK') {
							self.searchMobile(results[0].geometry.location.lat(), results[0].geometry.location.lng());
						} else {
							Message.error("No se encontró la dirección ingresada.");
						}
					});
				}
			});
			
			$('.btnGetGeoPosition').on('click', function(evt){
				evt.preventDefault();
				if (navigator.geolocation){
					navigator.geolocation.getCurrentPosition(
						function(position){
							var latitude=position.coords.latitude;
							var longitude=position.coords.longitude;
							$('.serviceForm .searchBtn').removeClass('disabled');
							
							var latlng = new google.maps.LatLng(latitude, longitude);          
							var geocoder = new google.maps.Geocoder();
							 geocoder.geocode({ 'latLng': latlng }, function (results, status) {
								if (status == google.maps.GeocoderStatus.OK) {
									if (results[0]) {
										for (var j = 0; j < results[0].address_components.length; j++) {
											if (results[0].address_components[j].types[0] == 'postal_code'){
												$('#search').val(results[0].address_components[j].short_name);
											}
										}
									}
								}
							 });
							 self.searchMobile(latitude, longitude);
						}, 
						function (error){
							switch(error.code) {
							  case error.PERMISSION_DENIED:
								Message.error("El usuario ha denegado el permiso a la localización.");
								break;
							  case error.POSITION_UNAVAILABLE:
								Message.error("La información de la localización no está disponible.");
								break;
							  case error.TIMEOUT:
								Message.error("El tiempo de espera para buscar la localización ha expirado.");
								break;
							  case error.UNKNOWN_ERROR:
								Message.error("Ha ocurrido un error desconocido.");
								break;
							  default:
								Message.error(error.message);
								break;
							  }
							}
					);
				}else {
					$('.btnGetGeoPosition').hide();
				}
			});

			$('.close').on('click', function(e) {
				e.preventDefault();
				$('.dealerForm').fadeOut();
			})
		});
		
	}
	
	searchDesktop(latitude, longitude){
		var self=this;

		var i=0;
		
		$('#dealerResult ul').html('');
		$('#dealerList li').each(function(){
			$(this).data('distance', self.distance(latitude, longitude, $(this).data('latitude'), $(this).data('longitude')));
		});

		$('#dealerList li').sort(function(a,b){
			if($(a).data('distance') < $(b).data('distance')) {
				return -1;
			} else {
				return 1;
			}
		}).each(function() { 
			if(i<3){
				$('#dealerResult ul').append($(this).clone());
			}
			i++;
		});


		if(self.myMarker){
			self.myMarker.setMap(null);
			self.myMarker=false;
		}
		
		var activeInfoWindow;
		var bounds = new google.maps.LatLngBounds();
		var carIcon = {
	        url: App.baseUrl + '/img/map-mark-car.svg',
	        anchor: new google.maps.Point(6,6),
	        scaledSize: new google.maps.Size(12,12)
	    };
		var marker = new google.maps.Marker({
			'position'	: new google.maps.LatLng(latitude, longitude),
			'map'		: self.map,
			'icon'		: carIcon,
		});

		google.maps.event.addListener(marker, 'click', (function (marker, i) {
			return function () {
			}
		})(marker, 1));
		bounds.extend(marker.getPosition());
		
		self.myMarker=marker;

		$('#dealerResult li').each(function(){
			var smallIcon = {
				url: App.baseUrl + '/img/map-mark.svg',
				//anchor: new google.maps.Point(30,30),
				scaledSize: new google.maps.Size(60,60)
			};
			var marker = new google.maps.Marker({
				'position'	: new google.maps.LatLng(Number($(this).data().latitude), Number($(this).data().longitude)),
				'map'		: self.map,
				'icon'		: smallIcon,
				'infoWindow': true,
			});
			const infowindow = new google.maps.InfoWindow({
			   content: `<div class="map-tooltip"><p>${$(this).data().name}</p><p>${$(this).data().address}</p><p>${$(this).data().location}</p></div>`,
			});

			google.maps.event.addListener(marker, 'click', (function (marker, i) {
				return function () {
					if (activeInfoWindow) { activeInfoWindow.close();}
					infowindow.open(self.map, marker);
					activeInfoWindow = infowindow;
				}
			})(marker, i));

			if(i==0){
				bounds.extend(marker.getPosition());
			}
		});
			
		$('#dealerResult ul li').show();
		self.map.fitBounds(bounds);
		
        $('#dealerResult li .showContact').on('click', function(e) {
            e.preventDefault();
            $('.dealerForm').fadeIn();
            $(this).addClass('active');
        });
        $('.dealerForm').on('click', function() {
            $(this).fadeOut();
            $('.showContact').removeClass('active');
        })
        $('.dealerForm form').on('click', function(e) {
            e.stopPropagation();
        })
        $('#dealerResult li').on('click', function() {
			$('#dealerResult li').removeClass('active');
			$(this).addClass('active');
			
			$('#dealer').val($(this).data().id).selectric('refresh');
			//$(this).trigger('map');

			self.map.setCenter(new google.maps.LatLng(Number($(this).data().latitude), Number($(this).data().longitude)) );
			self.map.setZoom(15);
        })

        $('.moreDealer').on('click', function(e) {
			e.preventDefault();
			$(this).closest('li').find('.more').slideToggle();
			$(this).toggleClass('active');
			var text = $(this).hasClass('active') ? 'Ver menos' : 'Ver más';
			$(this).text(text);
		})
 
		$('#dealerResult li .howToGet').on('click', function(evt){
			evt.preventDefault();
			
			if(self.activeRoute){
				self.activeRoute.setMap(null);
			}

			var directionsService = new google.maps.DirectionsService;
			var directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers:true});
			directionsDisplay.setMap(self.map);

			directionsService.route({
				origin: new google.maps.LatLng(self.myMarker.getPosition().lat(), self.myMarker.getPosition().lng()),
				destination: new google.maps.LatLng($(this).closest('li').data('latitude'), $(this).closest('li').data('longitude')),
				//waypoints: waypoints,
				//optimizeWaypoints: true,
				travelMode: google.maps.TravelMode.DRIVING
			}, function(response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
				} else {
					Message.error("No se pudo calcular la ruta.");
				}
			});
			self.activeRoute=directionsDisplay;
		});
		//$('#dealerResult li:first .howToGet').trigger('click');
		
		$('#dealerResult li:first').trigger('click');
	}
	
	searchMobile(latitude, longitude){
		var self=this;

		var i=0;
		
		$('#dealerResult ul').html('');
		$('#dealerList li').each(function(){
			$(this).data('distance', self.distance(latitude, longitude, $(this).data('latitude'), $(this).data('longitude')));
		});

		$('#dealerList li').sort(function(a,b){
			if($(a).data('distance') < $(b).data('distance')) {
				return -1;
			} else {
				return 1;
			}
		}).each(function() { 
			if(i<3){
				$('#dealerResult ul').append($(this).clone());
				//ojo
				//$('#dealerResult ul').append($(this).next().clone());
			}
			i++;
		});

		$('#dealerResult li').each(function(){
			$(this).show();
			$(this).find('.info').on('click', function() {
				$(this).closest('li').toggleClass('active');
				$(this).closest('li').find('.more').slideToggle();
			})
			
			var bounds = new google.maps.LatLngBounds();

			var self_map=$(this).find('.map.mobile div');
			//ojo
			//var self_map=$(this).next().find('div');
			self_map.css({'width' : '100%', 'height' : '100%'});

			self.maps_mobile[self_map.attr('id')] = new google.maps.Map(document.getElementById(self_map.attr('id')), {
				zoom: 13,
				center: new google.maps.LatLng(Number(self_map.closest('li').data().latitude), Number(self_map.closest('li').data().longitude)),
				//ojo
				//center: new google.maps.LatLng(Number(self_map.closest('.map').prev().data().latitude), Number(self_map.closest('.map').prev().data().longitude)),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true,
				zoomControl: true,
				scaleControl: true,
				scrollwheel: true,
			});

			var carIcon = {
				url: App.baseUrl + '/img/map-mark-car.svg',
				anchor: new google.maps.Point(6,6),
				scaledSize: new google.maps.Size(12,12)
			};
			var marker_origin = new google.maps.Marker({
				'position'	: new google.maps.LatLng(latitude, longitude),
				'map'		: self.maps_mobile[self_map.attr('id')],
				'icon'		: carIcon,
			});

			google.maps.event.addListener(marker_origin, 'click', (function (marker_origin, i) {
				return function () {
				}
			})(marker_origin, 1));
			bounds.extend(marker_origin.getPosition());

			var smallIcon = {
				url: App.baseUrl + '/img/map-mark.svg',
				//anchor: new google.maps.Point(30,30),
				scaledSize: new google.maps.Size(30,30)
			};
			var marker_destination = new google.maps.Marker({
				'position'	: new google.maps.LatLng(Number($(this).data().latitude), Number($(this).data().longitude)),
				//ojo
				//'position'  : new google.maps.LatLng(Number(self_map.closest('.map').prev().data().latitude), Number(self_map.closest('.map').prev().data().longitude)),
				'map'		: self.maps_mobile[self_map.attr('id')],
				'icon'		: smallIcon,
				'infoWindow': true,
			});
			const infowindow = new google.maps.InfoWindow({
			   content: `<div class="map-tooltip"><p>${$(this).data().name}</p><p>${$(this).data().address}</p><p>${$(this).data().location}</p></div>`,
			});

			google.maps.event.addListener(marker_destination, 'click', (function (marker_destination, i) {
				return function () {
					infowindow.open(self.maps_mobile[self_map.attr('id')], marker_destination);
				}
			})(marker_destination, i));
			bounds.extend(marker_destination.getPosition());


			self.maps_mobile[self_map.attr('id')].fitBounds(bounds);


			$(this).find('.howToGet').on('click', function(evt){
				evt.preventDefault();
				evt.stopPropagation();

				$('html, body').animate({scrollTop: $(this).closest('li').find('.map').offset().top-100});

				var directionsService = new google.maps.DirectionsService;
				var directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers:true});
				directionsDisplay.setMap(self.maps_mobile[self_map.attr('id')]);

				directionsService.route({
					origin: marker_origin.getPosition(),
					destination: marker_destination.getPosition(),
					travelMode: google.maps.TravelMode.DRIVING
				}, function(response, status) {
					if (status === 'OK') {
						directionsDisplay.setDirections(response);
					} else {
						Message.error("No se pudo calcular la ruta.");
					}
				});
			});
			$(this).find('.showContact').on('click', function(e) {
				e.preventDefault();
				
				$('#dealer').val($(this).closest('li').data().id).selectric('refresh');
				$('.dealerForm').fadeIn();
			});
		});
		
	}
	
	distance(lat1, lon1, lat2, lon2, unit) {
		if(typeof unit=='undefined') var unit='K';
		if ((lat1 == lat2) && (lon1 == lon2)) {
			return 0;
		}
		else {
			var radlat1 = Math.PI * lat1/180;
			var radlat2 = Math.PI * lat2/180;
			var theta = lon1-lon2;
			var radtheta = Math.PI * theta/180;
			var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = dist * 180/Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit=="K") { dist = dist * 1.609344 }
			if (unit=="N") { dist = dist * 0.8684 }
			return dist;
		}
	}
}

export default ServiceFind;